import React, { useState } from "react";

import { Card, CardBody, Table, Badge, Button, Input, Spinner, } from "reactstrap";

import Breadcrumbs from "../../components/Common/Breadcrumb";

import FbTokenModal from "../../Modal/Facebook/FbTokenModal";
import LeadSyncSettingsModal from "../../Modal/Facebook/LeadSyncSettingsModal";
import FbTokenSetupModal from "../../components/FbLeadgen/FbTokenSetupModal";

import useFbTokens from "../../Hooks/useFbTokens";

const TokenManager = () => {

  const { tokens, loading, fetchTokens, createToken, updateToken, deleteToken, } = useFbTokens();

  const [open, setOpen] = useState(false);
  const [setupOpen, setSetupOpen] = useState(false);
  const [leadSyncModal, setLeadSyncModal] = useState(false);
  const [selected, setSelected] = useState(null);
  const [search, setSearch] = useState("");

  const filteredTokens = tokens.filter((item) =>
    item?.name?.toLowerCase()?.includes(search.toLowerCase()) ||
    item?.refId?.toLowerCase()?.includes(search.toLowerCase()) ||
    item?.type?.toLowerCase()?.includes(search.toLowerCase())
  );

  return (
    <div className="page-content">

      <Breadcrumbs title="Settings" breadcrumbItem="FB Token Manager" />

      <Card>

        <CardBody>

        <div className="row g-2 mb-3">

          <div className="col-12 col-md">
            <Input
              placeholder="Search token..."
              value={search}
              onChange={(e)=>setSearch(e.target.value)}
            />
          </div>

          <div className="col-12 col-md-auto">
            <div className="d-flex flex-wrap gap-2 justify-content-md-end">

              <Button color="primary" onClick={()=>setLeadSyncModal(true)}>
                <i className="mdi mdi-sync" />
                <span className="ms-1 d-none d-md-inline">Lead Sync</span>
              </Button>

              <Button color="primary" onClick={()=>setSetupOpen(true)}>
                <i className="mdi mdi-auto-fix" />
                <span className="ms-1 d-none d-md-inline">Auto Setup</span>
              </Button>

              <Button
                color="primary"
                onClick={()=>{
                  setSelected(null);
                  setOpen(true);
                }}
              >
                <i className="mdi mdi-plus-circle" />
                <span className="ms-1 d-none d-md-inline">Manual Token</span>
              </Button>

            </div>
          </div>

        </div>


          <Table bordered hover responsive>

            <thead>
              <tr>
                <th>Name</th>
                <th>Ref ID</th>
                <th>Type</th>
                <th>Status</th>
                <th>Updated</th>
                <th width="140">Actions</th>
              </tr>
            </thead>

            <tbody>

              {loading ? (
                <tr>
                  <td colSpan="6" className="text-center">
                    <Spinner size="sm" />
                  </td>
                </tr>
              ) : filteredTokens.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center">
                    No Tokens Found
                  </td>
                </tr>
              ) : (
                filteredTokens.map((t) => (
                  <tr key={t._id}>

                    <td>{t.name}</td>

                    <td>{t.refId}</td>

                    <td>
                      <Badge color={t.type === "page" ? "warning" : "primary"}>
                        {t.type}
                      </Badge>
                    </td>

                    <td>
                      <Badge color={t.isActive ? "success" : "danger"}>
                        {t.isActive ? "Active" : "Inactive"}
                      </Badge>
                    </td>

                    <td>
                      {new Date(t.updatedAt).toLocaleString()}
                    </td>

                    <td>

                      <div className="d-flex gap-2">

                        <i
                          className="mdi mdi-pencil text-primary"
                          style={{ cursor: "pointer", fontSize: 22 }}
                          onClick={() => {
                            setSelected(t);
                            setOpen(true);
                          }}
                        />

                        <i
                          className="mdi mdi-delete text-danger"
                          style={{ cursor: "pointer", fontSize: 22 }}
                          onClick={() => deleteToken(t._id)}
                        />

                      </div>

                    </td>

                  </tr>
                ))
              )}

            </tbody>

          </Table>

        </CardBody>

      </Card>

      <FbTokenModal
        isOpen={open}
        toggle={() => setOpen(false)}
        selected={selected}
        onSave={selected ? updateToken : createToken}
      />

      <FbTokenSetupModal
        isOpen={setupOpen}
        toggle={() => setSetupOpen(false)}
        refresh={fetchTokens}
      />

      <LeadSyncSettingsModal
        isOpen={leadSyncModal}
        toggle={() => setLeadSyncModal(false)}
      />

    </div>
  );
};

export default TokenManager;